import React, { Component } from 'react';

export default class NotLoggedIn extends Component {
  render() {

    return (
      <div id="kakaoContent" className="cont_bridge cont_inter" role="main">
        <span className="img_bridge" />
        <strong className="tit_bridge">로그아웃 되었습니다.</strong>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/components/ErrorContent/NotLoggedIn.js